<template>
  <!-- 维码器协议 -->
      <div class="agrees">
          <div class="agree-one">
            <h2 class="agree-title">扬盛科技维码器服务条款</h2>
            <p class="welcome"><strong>欢迎申请和使用扬盛计算机科技软件有限公司及其他合作运营主体（下列简称“扬盛科技”或“扬盛”）提供的服务。</strong>请您（下列简称“用户”）仔细阅读以下全部内容<strong>（特别是粗体下划线标注的内容）</strong>。如用户不同意本服务条款的任意内容，请勿注册或使用扬盛提供的服务。如用户通过注册或登录进入相关服务页面，即表示用户与扬盛公司已达成协议，自愿接受本服务条款的所有内容。此后，用户不得以未阅读本服务条款内容作任何形式的抗辩。</p>
            <div class="agree-items">
                <p>1.扬盛服务简介 <br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;扬盛服务是指基于维码器或扬盛公司的其他产品向用户所提供的系统服务，但不包括与本公司结合使用的其他产品。其他产品是指，如采购扬盛公司产品装置于特定服务设备上，设备用于整机出售或提供服务的。对于此类产品，扬盛公司只服务自家产品的相关软件和硬件。
                </p>
                <p>
                    2.账号注册及使用规则 <br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用户在注册扬盛相关产品或服务的账号时承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共制序、社会道德风尚和信息真实性等七条底线，且用户保证其在注册和使用账号时，不得有以下情形：<br/>
                    &nbsp;&nbsp;&nbsp;1.违反宪法或法律法规规定的； <br/>
                    &nbsp;&nbsp;&nbsp;2.危害国家安全，泄露国家机密，颠覆国家政权，破坏国家统一的； <br/>
                    &nbsp;&nbsp;&nbsp;3.损害国家荣誉和利益的，损害公共利益的； <br/>
                    &nbsp;&nbsp;&nbsp;4.煽动民族仇恨、民族歧视，破坏民族团结的； <br/>
                    &nbsp;&nbsp;&nbsp;5.破坏国家宗教政策，宣扬邪教和封建迷信的； <br/>
                    &nbsp;&nbsp;&nbsp;6.散布谣言，扰乱社会秩序，破坏社会稳定的； <br/>
                    &nbsp;&nbsp;&nbsp;7.散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的； <br/>
                    &nbsp;&nbsp;&nbsp;8.侮辱或诽谤他人，侵害他人合法权益的； <br/>
                    &nbsp;&nbsp;&nbsp;9.含有法律、行政法规禁止的其他内容的； <br/>
                    若用户提供给扬盛公司的账号注册资料不准确，不真实，含有违法或不良信息的，扬盛公司有权采取通知期限改正、暂停使用、注销登记等措施。根据相关法律、法规规定以及考虑到扬盛产品服务的重要性，用户同意：<br/>
                    &nbsp;&nbsp;&nbsp;1.在注册账号或完善账号信息时提交真实的个人有效身份信息进行认证； <br/>
                    &nbsp;&nbsp;&nbsp;2.配合产品服务迭代，提交详尽准确的资料； <br/>
                        <strong>为了让用户及时、方便的使用扬盛提供的各项服务，用户同意，扬盛公司可以多次、长期向用户发送各类服务短信而无需另行获得用户的同意。
                        用户同意与注册、使用扬盛平台账号相关的以切资料、数据和记录，包括但不限于账号本身、注册资料或后续补充的资料、所有操作记录、消费记录和相关的使用统计数据等都归扬盛公司所有。发生争议时，用户同意以扬盛公司的系统数据为准，扬盛公司保证该数据的真实性。
                        </strong>
                </p>
                <p>
                    3.服务条款的修改 <br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;扬盛公司有权在必要时通过网页或app等方式，向用户发出公告等合理方式修改本服务条款以及各单项服务的相关条款。用户在享受各项服务时，应当及时查阅了解修改的内容，并自觉遵守本服务条款涉及的各项内容。用户如继续使用本服务条款涉及的服务，则视为对修改内容的同意，当发生争议时，以最新的服务条款为准；用户在不同意修改内容的情况下，有权停止使用本服务条款涉及的服务。
                </p>
                <p>
                    <strong>4.服务的变更或终止 <br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;扬盛公司始终在不断变更和改进服务。扬盛公司可能会增加或删除功能，也可能暂停或彻底停止某项服务。用户同意扬盛公司有权行使上述权利且不需对用户或第三方承担任何责任。
                    </strong>
                </p>
                <p>
                    <strong>5.用户隐私制度 <br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;尊重用户的隐私是扬盛公司的一项基本政策。扬盛公司会按相关隐私政策收集、存储、使用、披露和保护您的个人信息。
                    </strong>
                </p>
                <p>
                    6.用户的账号安全性 <br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用户一旦注册或登录成为用户，用户将得到一个账号或账号关联的其他第三方登录授权方式。用户应当维持账号的机密安全，如果用户未保管好自己的账号和密码而对用户、扬盛公司或第三方造成损害，用户将负全部责任。用户同意若发现任何非法使用用户账号或安全漏洞的情况，有义务立即通告扬盛公司。
                </p>
                <p>
                    7.委托代收款 <br/>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用户有权选择自己的收款方式，如用户要求或需要扬盛公司帮忙代收款项的，则表示同意本条款内容及扬盛公司在该单项服务中发出的<strong>“单项条款”</strong>。<strong>委托代收款指的是，用户委托扬盛公司代为收取用户在经营过程中的相关款项，之后用户以申请提现的方式或扬盛公司主动向用户汇款转账</strong>。
                </p>
                <p>
                    <strong>8.不可抗力条款 <br/>
                    &nbsp;&nbsp;&nbsp;&nbsp;扬盛公司对不可抗力导致的损失不承担责任。本服务条款所指不可抗力包括：天灾、法律法规或政府指令的变更，因网络服务特性而特有的原因，例如境内外基础电信运营商的故障、计算机病毒、黑客攻击等因素，及其他合法范围内的不能预见、不能避免且不能克服的客观情况。
                    </strong>
                </p>
            </div>
          </div>
      </div>
</template>

<script>
export default {
  name:"agree",
}
</script>

<style scoped>
.agrees{
    width: 100%;
    height: 100%;
     display: flex;
    justify-content: center;
    align-items: center;
}
/* .agrees.up{
    transform: translateY(-100%);
} */
.agrees p,.agrees h2{
    font-family: 微软雅黑;
}
.agrees .agree-one{
    width: 1200px;
    height: 100%;
    background: #fff;
    line-height: 35px;
    padding: 100px 55px 55px 55px;
    box-sizing: border-box;
    font-family: 微软雅黑;
    overflow: auto;
}
.agree-title,.welcome{
    margin-top: 25px;
}
.agrees .closes{
        display: flex;
    justify-content: flex-end;
    cursor: pointer;
}
.agrees .agree,.agrees .agree-title{
    text-align: center;
}
.agrees .welcome{
    text-indent: 2em;
}
.agrees strong{
    text-decoration: underline;
}

@media screen and (max-width:768px){
    .agrees .agree-one{
        width: 100%;
        padding: 0px 20px;
        box-sizing: border-box;
            margin-top: 90px;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/login/agree.vue